import script from "./GodApeQuestWalletItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestWalletItem.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestWalletItem.vue?vue&type=style&index=0&id=7c6992a8&lang=scss"

const __exports__ = script;

export default __exports__